<template>
	<div>
		<h6 class="ml-2"><strong>Agency Details</strong></h6>
		<form @submit.prevent="postIntegrationSettings" class="mb-3">
			<div class="row p-3">

				<div class="col">
					<div class="form-group input-content">
						<label>Discipline</label>
						<div class="input-content input-content-horizontal">
							<v-select :searchable="false" name="integration_options" multiple  v-model="editable_org_integration.discipline" :options="discipline" label="name" class="status_import v-select-no-height"></v-select>
						</div>
					</div>

					<label>Active Integration</label>
					<div class="mt-2">
						<date-picker placeholder="Active integration date" class="date_picker_new" v-model="editable_org_integration.active_int_date" 
							:range="false" 
							:format="'MM-DD-YYYY'"
							:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
							:valueType="'YYYY-MM-DD'">
						</date-picker>
					</div>

					<div class="mt-2">
						<button type="submit" class="button large-button integration-button">Save Integration</button>
					</div>
				</div>

				<div class="col">
				</div>
				<div class="col">
				</div>
			</div>

			
		</form>
	</div>
</template>
<script>
export default {	
	props:{
		integration_id: Number
	},
	data : function(){
		return{
			name: '',
			picked: 'No',
			import_applicants:0,
			realtime_report:1,
			selected_frequencies: ["daily"],
			discipline: [
				{id: 0, name: 'ADM'},
				{id: 1, name: 'APC'},
				{id: 2, name: 'CBSA'},
				{id: 3, name: 'CH'},
				{id: 4, name: 'CNA'},
				{id: 5, name: 'COMP'},
				{id: 6, name: 'ESC'},
				{id: 7, name: 'HCSS'},
				{id: 8, name: 'HHA'},
				{id: 9, name: 'HHA -C'},
				{id: 10, name: 'HM'},
				{id: 11, name: 'HMK'},
				{id: 12, name: 'HSK'},
				{id: 13, name: 'ILST'},
				{id: 14, name: 'LPN'},
				{id: 15, name: 'MSW'},
				{id: 16, name: 'NINS'},
				{id: 17, name: 'NT'},
				{id: 18, name: 'OT'},
				{id: 19, name: 'PA'},
				{id: 20, name: 'PBIS'},
				{id: 21, name: 'PC'},
				{id: 22, name: 'PCA'},
				{id: 23, name: 'PT'},
				{id: 24, name: 'RESP'},
				{id: 25, name: 'RN'},
				{id: 26, name: 'RT'},
				{id: 27, name: 'SCI'},
				{id: 28, name: 'SCM'},
				{id: 29, name: 'SDP'},
				{id: 30, name: 'SHC'},
				{id: 31, name: 'SHHA'},
				{id: 32, name: 'SPC'},
				{id: 33, name: 'ST'},
				{id: 34, name: 'Other (Skilled)'},
				{id: 35, name: 'Other (Non Skilled)'},
			],
			org_integration:{
				active_int_date: '',
				discipline: '',
			},
			editable_org_integration:{
				active_int_date: '',
				discipline: '',
				},
			temp_org_integration: {}
			
		}
	},
	created : function(){
		// this.org_integration.id = this.$route.params.id
		// this.org_integration.integration_id = this.integration_id
		this.getIntegrationSettings()

	},
	methods : {
		getIntegrationSettings(){ 
			var params = {
				id: this.$route.params.agency_id,
				integration_id: this.integration_id,
			}
			this.$store.dispatch('getOrganizationIntegrationSettings', params).then((res) => {
				if(res.data.length == 0){
				}else{
					this.assignKeyValues(res.data, this.editable_org_integration)
					this.assignKeyValues(res.data, this.org_integration)
					if(res.data.discipline){
						this.getDiciplineValues(res.data)
						this.editable_org_integration.discipline = this.org_integration.discipline
					}
				}
				
			
			}).catch((error) => {
					console.log(error);
			});
		},
		postIntegrationSettings(){ 
			this.temp_org_integration = this.removeEmptyKeyValues(this.editable_org_integration)
			if(this.temp_org_integration.discipline){
				this.temp_org_integration.discipline = this.temp_org_integration.discipline.map(elem =>{ return elem.id })
			}
			var params = {
				id: this.$route.params.agency_id,
				integration_id: this.integration_id,
				filters: this.temp_org_integration
			}

			this.$store.dispatch('UpdateOrganizationIntegrationSettings', params).then((res) => {
				this.temp_org_integration = {}
				this.getIntegrationSettings()
			
			}).catch((error) => {
					console.log(error);
			});
		},
		getDiciplineValues(res){
			if(typeof this.org_integration.discipline != Array){
				this.org_integration.discipline = [...this.org_integration.discipline]
			}
			this.discipline.forEach(elem => {
				if(res.discipline.includes(elem.id.toString())){
					this.org_integration.discipline.push(elem)
				}
			})
			this.org_integration.discipline = this.org_integration.discipline.filter(elem => {if(typeof elem === 'object'){
				return elem
			}})
		},
		removeEmptyKeyValues: function(obj){
			var new_obj = {}
			  for (var propName in obj) {
				if ( obj[propName] != '') {
					new_obj[propName] = obj[propName]
				}
			}
			return new_obj
		},
		assignKeyValues: function(obj, obj_to_assign){
			for (var propName in obj) {
				if ( obj[propName] != '') {
					obj_to_assign[propName] = obj[propName]
				}
			}
		}

	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/organization/integration/AlayacareIntegration.vue